var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFEEDC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_3116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0014 18H44.0014C45.1077 18 46.0014 18.8937 46.0014 20C46.0014 21.1062 45.1077 22 44.0014 22H36.9014C36.5764 23.6125 35.4702 24.9438 34.0014 25.5813V44H44.0014C45.1077 44 46.0014 44.8937 46.0014 46C46.0014 47.1063 45.1077 48 44.0014 48H32.0014H20.0014C18.8952 48 18.0014 47.1063 18.0014 46C18.0014 44.8937 18.8952 44 20.0014 44H30.0014V25.5813C28.5327 24.9375 27.4264 23.6062 27.1014 22H20.0014C18.8952 22 18.0014 21.1062 18.0014 20C18.0014 18.8937 18.8952 18 20.0014 18H28.0014C28.9139 16.7875 30.3639 16 32.0014 16C33.6389 16 35.0889 16.7875 36.0014 18ZM39.4764 36H48.5327L44.0014 28.2375L39.4764 36ZM44.0014 42C40.0702 42 36.8014 39.875 36.1264 37.0688C35.9639 36.3813 36.1889 35.675 36.5452 35.0625L42.4952 24.8625C42.8077 24.325 43.3827 24 44.0014 24C44.6202 24 45.1952 24.3313 45.5077 24.8625L51.4577 35.0625C51.8139 35.675 52.0389 36.3813 51.8764 37.0688C51.2014 39.875 47.9327 42 44.0014 42ZM19.9264 28.2375L15.4014 36H24.4577L19.9264 28.2375ZM12.0577 37.0688C11.8952 36.3813 12.1202 35.675 12.4764 35.0625L18.4264 24.8625C18.7389 24.325 19.3139 24 19.9327 24C20.5514 24 21.1264 24.3313 21.4389 24.8625L27.3889 35.0625C27.7452 35.675 27.9702 36.3813 27.8077 37.0688C27.1264 39.875 23.8577 42 19.9264 42C15.9952 42 12.7327 39.875 12.0577 37.0688Z",
    fill: "#E59D22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_3116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeigh);
export default __webpack_public_path__ + "static/media/weigh.f5f10990cd9f61f9fcf1070118daf745.svg";
export { ForwardRef as ReactComponent };